import type { CopyShape } from "@tami/core/intl";

import type { WEB_SHELL_COPY_PT_BR } from "../web-shell.copy";

export const WEB_SHELL_COPY_EN_US: CopyShape<typeof WEB_SHELL_COPY_PT_BR> = {
  footer: {
    logoAlt: "Tãmi logo",
    tagline: "You create. Tãmi organizes.",
    rights: "Tãmi. All rights reserved.",
    supportWhatsApp: (phone: string): string => `WhatsApp support: ${phone}`,
  },
  cookies: {
    before:
      "We use cookies and session recording to understand how the app is used and make Tãmi better. We don't sell your data or use it for ads. If you decline, we stop measuring and recording.",
    privacyLink: "Privacy policy",
    accept: "Accept",
    decline: "Decline",
    close: "Close",
  },
  bioSite: {
    logoAlt: "Tãmi",
    socialNavAria: "Tãmi's social accounts",
    featuresNavAria: "Features",
    linksNavAria: "Main links",
    whatsapp: "WhatsApp",
    email: "Email",
  },
  legalDocument: {
    updatedAt: "Last updated on",
    taxId: "CNPJ",
  },
  hideValues: {
    show: "Show values",
    hide: "Hide values",
  },
  sponsoredBilling: {
    before: "Subscription paid for by",
    after: ". To change your plan or payment, talk to the Collab.",
  },
  sessionRevoke: {
    sessionIn: "The session on",
    afterSession: "will end, and you'll need to sign in there again.",
  },
  modal: {
    close: "Close modal",
  },
  floatingRefresh: {
    aria: "Reload page",
  },
  loading: {
    page: "Loading page",
    navigation: "Loading navigation",
  },
  mainNavigationAria: "Main navigation",
  allPlatforms: "All platforms",
};
